<template>
    <div>
        <ul class="list-group mt-3">
            <li class="list-group-item" v-if="exibir_prazo && prazo_final">
                <a href="#" @click.prevent="exibir_dias = !exibir_dias" class="mr-3">
                    <i class="fa-regular fa-square-plus fa-fw" v-if="!exibir_dias"></i>
                    <i class="fa-regular fa-square-minus fa-fw" v-else></i>
                </a>
                <span>Prazo: {{ $util.getFormatDate(prazo_final) }}</span>

                <table class="table table-sm mt-3 mb-0" v-if="exibir_dias">
                    <tbody>
                        <tr v-for="(exames, prazo, chave) in lista_prazos" :key="chave" :class="!tem_exames(exames) ? 'table-secondary' : ''">
                            <td width="1%" :class="tem_exames(exames) ? '' : 'text-muted'">{{ $util.getFormatDate(prazo) }}</td>
                            <td width="1%"><span class="badge badge-secondary mr-1">{{ exames.length }}</span></td>
                            <td>
                                <span class="badge badge-pill mr-1" 
                                    :class="'badge-' + cor_exame(exame)"
                                    :title="( exame.procedimento ? exame.procedimento.st_procedimento : '' ) +   
                                        ( ( exame.js_solics && exame.js_solics.terc == 'S' ) ? ' / Terceirizado' : '' )"
                                    v-for="(exame, iex) in exames" :key="iex">
                                    {{ exame.procedimento.st_sigla }}

                                    <span class="ml-1" v-if="exame.fl_urgente">
                                        <template v-if="exame.dt_entrega && exame.dt_entrega.slice(11,16) && ( exame.dt_entrega.slice(11,16) != '00:00' )">
                                            {{ exame.dt_entrega.slice(11,16) }}
                                        </template>
                                        <i class="fa-solid fa-circle-exclamation text-danger ml-1" title="Urgente"></i>
                                    </span>
                                    <span class="ml-1" v-if="exame.js_solics && exame.js_solics.terc == 'S'">
                                        <i class="fa-solid fa-location-pin"></i>
                                    </span>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </li>
            <li class="list-group-item d-flex justify-content-between" v-for="(acesso, ilx) in terceiro_logins" :key="ilx">
                <div>
                    <a href="#" @click.prevent="exibir_login = !exibir_login" class="mr-3">
                        <i class="fa-solid fa-eye-slash fa-fw" v-if="!exibir_login"></i>
                        <i class="fas fa-eye fa-fw" v-else></i>
                    </a>
                    <span v-if="exibir_login">Login: {{ acesso.st_login }} / Senha: {{ acesso.st_senha }}</span>
                    <span v-else>Login: ****** / Senha: *******</span>
                </div>
                <div>
                    <span class="small text-muted" v-if="acesso.terceiro">{{ acesso.terceiro.st_sigla }}</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    data() { 
        return { 
            exibir_login: false, 
            exibir_dias: false, 
        };
    },

    props: ['marcacao', 'exibir_prazo'],

    computed: { 
        lista_prazos: function () { 
            if ( !this.marcacao || !this.marcacao.atendimento || !this.marcacao.atendimento.atendimento_procedimentos )
                return;

            if ( !this.marcacao.st_id_externo && !( this.marcacao.procedimento && this.marcacao.procedimento.id_especialidade && this.marcacao.procedimento.id_especialidade != 2 ) ) 
                return;

            return _.groupBy(
                _.orderBy(
                    this.marcacao.atendimento.atendimento_procedimentos.filter(item => item.dt_entrega),
                    'dt_entrega'
                ),  
                item => item.dt_entrega.slice(0,10)
            );
        },

        prazo_final: function () { 
            if ( !this.marcacao || !this.marcacao.atendimento || !this.marcacao.atendimento.atendimento_procedimentos )
                return;

            if ( !this.marcacao.st_id_externo && !( this.marcacao.procedimento && this.marcacao.procedimento.id_especialidade && this.marcacao.procedimento.id_especialidade != 2 ) ) 
                return;

            const maior = _.maxBy(this.marcacao.atendimento.atendimento_procedimentos.filter(item => !( item.laudo && item.laudo.status_laudo && item.laudo.status_laudo.fl_nao_coletar ) ), 'dt_entrega');

            return maior ? maior.dt_entrega : null;
        },

        terceiro_logins: function () { 
            if ( !this.marcacao || !this.marcacao.terceiro_logins || !this.marcacao.terceiro_logins.length )
                return [];

            return this.marcacao.terceiro_logins;
        },

    },

    methods: { 
        tem_exames (lista) { 
            return lista.find(item => !( item.laudo && item.laudo.status_laudo && item.laudo.status_laudo.fl_nao_coletar )) ? true : false; 
        },

        cor_exame (exame) { 
            if ( !exame ) { 
                return 'secondary';
            }

            if ( exame.laudo && exame.laudo.status_laudo && exame.laudo.status_laudo.fl_nao_coletar ) { 
                return 'danger';
            }

            if ( exame.js_solics && exame.js_solics.terc == 'S' ) { 
                return 'info';
             }
             
             return 'primary';
        }
    }

}
</script>